import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
import {FaReact, FaHtml5, FaCss3Alt, FaJs, FaPython, FaGitAlt, FaJava, FaAngular} from 'react-icons/fa'
import {SiCsharp, SiMysql, SiMicrosoftazure, SiMongodb, SiFirebase, SiAndroidstudio, SiLinux, SiPowershell} from 'react-icons/si'
import {DiAndroid} from 'react-icons/di'

const Experience = () => {
  // Debug log to ensure component is rendering
  console.log('Experience component is rendering');
  
  return (
    <section id='experience' style={{backgroundColor: 'var(--color-bg)', minHeight: '100vh'}}>
      <div className="experience__header">
        <span className="experience__badge">Skills & Expertise</span>
        <h2>Technical Proficiency</h2>
        <p className="experience__subtitle">Technologies and tools I work with to bring ideas to life</p>
      </div>
      
      <div className="container experience__container">
        <div className="experience__frontend">
          <div className="experience__category-header">
            <h3>Frontend Development</h3>
            <p>Creating engaging user interfaces and responsive web applications</p>
          </div>
          <div className="experience__content">
            <article className='experience__details'>
              <FaHtml5 className='experience__details-icon html' />
              <div>
                <h4>HTML5</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <FaCss3Alt className='experience__details-icon css' />
              <div>
                <h4>CSS3</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <FaJs className='experience__details-icon js' />
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <FaReact className='experience__details-icon react' />
              <div>
                <h4>React</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <FaAngular className='experience__details-icon angular' />
              <div>
                <h4>Angular</h4>
                <small className='text-light'>Competent</small>
              </div>
            </article>
            <article className='experience__details'>
              <DiAndroid className='experience__details-icon android' />
              <div>
                <h4>Android Dev</h4>
                <small className='text-light'>Competent</small>
              </div>
            </article>
          </div>
        </div>
        {/* END OF FRONTEND */}

        <div className="experience__backend">
          <div className="experience__category-header">
            <h3>Backend & Programming</h3>
            <p>Server-side development and system programming</p>
          </div>
          <div className="experience__content">
            <article className='experience__details'>
              <FaJava className='experience__details-icon java' />
              <div>
                <h4>Java</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <FaPython className='experience__details-icon python' />
              <div>
                <h4>Python</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiCsharp className='experience__details-icon csharp' />
              <div>
                <h4>C# / C++</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>SQL</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiPowershell className='experience__details-icon powershell' />
              <div>
                <h4>Shell/Bash</h4>
                <small className='text-light'>Competent</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>MATLAB</h4>
                <small className='text-light'>Competent</small>
              </div>
            </article>
          </div>
        </div>
      </div>

      {/* Add new section for Tools & Platforms */}
      <div className="container experience__container" style={{marginTop: '3rem'}}>
        <div className="experience__frontend">
          <div className="experience__category-header">
            <h3>Databases & Cloud</h3>
            <p>Data management and cloud computing solutions</p>
          </div>
          <div className="experience__content">
            <article className='experience__details'>
              <SiFirebase className='experience__details-icon firebase' />
              <div>
                <h4>Firebase</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiMongodb className='experience__details-icon mongodb' />
              <div>
                <h4>MongoDB</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiMysql className='experience__details-icon mysql' />
              <div>
                <h4>SQL/H2</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiMicrosoftazure className='experience__details-icon azure' />
              <div>
                <h4>Azure Cloud</h4>
                <small className='text-light'>Certified</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiLinux className='experience__details-icon linux' />
              <div>
                <h4>Linux/Unix</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>macOS</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__backend">
          <div className="experience__category-header">
            <h3>Developer Tools</h3>
            <p>Development environment and productivity tools</p>
          </div>
          <div className="experience__content">
            <article className='experience__details'>
              <FaGitAlt className='experience__details-icon git' />
              <div>
                <h4>Git & GitHub</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiMicrosoftazure className='experience__details-icon azure' />
              <div>
                <h4>Azure DevOps</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>VS Code</h4>
                <small className='text-light'>Expert</small>
              </div>
            </article>
            <article className='experience__details'>
              <SiAndroidstudio className='experience__details-icon android-studio' />
              <div>
                <h4>Android Studio</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>IntelliJ IDEA</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
            <article className='experience__details'>
              <BsPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>PyCharm</h4>
                <small className='text-light'>Proficient</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience